import ArtifactGroupType from "../base/ArtifactGroupType";


const ProwOfVinland = {
  id: '120',
  name: 'Prow Of Vinland',
  groupIcon: 'EchoesOfTheNorth',
  type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
  icon: 'ProwOfVinland',
  power: 50
};

export default ProwOfVinland;
